import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    }, {
        path: '/searchHouse',
        name: 'searchHouse',
        component: () => import('../views/searchHouse.vue')
    }, {
        path: '/hotCity',
        name: 'hotCity',
        component: () => import('../views/hotCity.vue')
    }, {
        path: '/tokyoHouse',
        name: 'tokyoHouse',
        component: () => import('../views/tokyoHouse.vue')
    }, {
        path: '/shuttlePlane',
        name: 'shuttlePlane',
        component: () => import('../views/shuttlePlane.vue')
    }, {
        path: '/houseDetail',
        name: 'houseDetail',
        component: () => import('../views/houseDetail.vue')
    }, {
        path: '/lineDetail',
        name: 'lineDetail',
        component: () => import('../views/lineDetail.vue')
    }, {
        path: '/storyList',
        name: 'storyList',
        component: () => import('../views/storyList.vue')
    }, {
        path: '/hotSpringDetail',
        name: 'hotSpringDetail',
        component: () => import('../views/story/hotSpringDetail.vue')
    }, {
        path: '/sceneDetail',
        name: 'sceneDetail',
        component: () => import('../views/story/sceneDetail.vue')
    }, {
        path: '/cateDetail',
        name: 'cateDetail',
        component: () => import('../views/story/cateDetail.vue')
    }, {
        path: '/shuttleResult',
        name: 'shuttleResult',
        component: () => import('../views/shuttleResult.vue')
    }, {
        path: '/shuttleReservation',
        name: 'shuttleReservation',
        component: () => import('../views/shuttleReservation.vue')
    }, {
        path: '/shuttlePay',
        name: 'shuttlePay',
        component: () => import('../views/shuttlePay.vue')
    }, {
        path: '/center',
        name: '/center',
        redirect: '/center/userCenter',
        component: () => import('../views/center/index.vue'),
        children: [
            {
                path: '/center/userCenter',
                name: 'userCenter',
                component: () => import('../views/center/userCenter.vue')
            }, {
                path: '/center/msgCenter',
                name: 'msgCenter',
                component: () => import('../views/center/msgCenter.vue')
            }, {
                path: '/center/collection',
                name: 'collection',
                component: () => import('../views/center/collection.vue')
            }, {
                path: '/center/myNeeder',
                name: 'myNeeder',
                component: () => import('../views/center/myNeeder.vue')
            }, {
                path: '/center/myOrder',
                name: 'myOrder',
                component: () => import('../views/center/myOrder.vue')
            }, {
                path: '/center/myEvaluate',
                name: 'myEvaluate',
                component: () => import('../views/center/myEvaluate.vue')
            }, {
                path: '/center/landlordOrder',
                name: 'landlordOrder',
                component: () => import('../views/center/landlordOrder.vue')
            }, {
                path: '/center/houseManage',
                name: 'houseManage',
                component: () => import('../views/center/houseManage.vue')
            }, {
                path: '/center/addHouse',
                name: 'addHouse',
                component: () => import('../views/center/addHouse.vue')
            }, {
                path: '/center/myStory',
                name: 'myStory',
                component: () => import('../views/center/myStory.vue')
            }, {
                path: '/center/addStory',
                name: 'addStory',
                component: () => import('../views/center/addStory.vue')
            }, {
                path: '/center/withdraw',
                name: 'withdraw',
                component: () => import('../views/center/withdraw.vue')
            }, {
                path: '/center/landlordEvaluate',
                name: 'landlordEvaluate',
                component: () => import('../views/center/landlordEvaluate.vue')
            }, {
                path: '/center/evaluateList',
                name: 'evaluateList',
                component: () => import('../views/center/evaluateList.vue')
            }, {
                path: '/center/driverEvaluate',
                name: 'driverEvaluate',
                component: () => import('../views/center/driverEvaluate.vue')
            }, {
                path: '/center/statisticsLandord',
                name: 'statisticsLandord',
                component: () => import('../views/center/statisticsLandord.vue')
            }, {
                path: '/center/statisticsDriver',
                name: 'statisticsDriver',
                component: () => import('../views/center/statisticsDriver.vue')
            }, {
                path: '/center/driverOrder',
                name: 'driverOrder',
                component: () => import('../views/center/driverOrder.vue')
            }, {
                path: '/center/shuttleManage',
                name: 'shuttleManage',
                component: () => import('../views/center/shuttleManage.vue')
            }, {
                path: '/center/addCar',
                name: 'addCar',
                component: () => import('../views/center/addCar.vue')
            }, {
                path: '/center/lineManage',
                name: 'lineManage',
                component: () => import('../views/center/lineManage.vue')
            }, {
                path: '/center/addLine',
                name: 'addLine',
                component: () => import('../views/center/addLine.vue')
            }, {
                path: '/center/robOrder',
                name: 'robOrder',
                component: () => import('../views/center/robOrder.vue')
            }, {
                path: '/center/feedback',
                name: 'feedback',
                component: () => import('../views/center/feedback.vue')
            }, {
                path: '/center/contactService',
                name: 'contactService',
                component: () => import('../views/center/contactService.vue')
            }, {
                path: '/center/question',
                name: 'question',
                component: () => import('../views/center/question.vue')
            }, {
                path: '/center/clause',
                name: 'clause',
                component: () => import('../views/center/clause.vue')
            }, {
                path: '/center/aboutUs',
                name: 'aboutUs',
                component: () => import('../views/center/aboutUs.vue')
            }
        ]
    }, {
        path: '/question',
        component: () => import('../views/center/question.vue')
    }, {
        path: '/clause',
        component: () => import('../views/center/clause.vue')
    }, {
        path: '/aboutUs',
        component: () => import('../views/center/aboutUs.vue')
    }, {
        path: '/driverDetail',
        component: () => import('../views/driverDetail.vue')
    }, {
        path: '/landlordDetail',
        component: () => import('../views/landlordDetail.vue')
    }, {
        path: '/contactService',
        component: () => import('../views/center/contactService.vue')
    }, {
        path: '/coupon',
        name: 'coupon',
        component: () => import('../views/coupon.vue')
    }, {
        path: '/couponDetail',
        name: 'couponDetail',
        component: () => import('../views/couponDetail.vue')
    }, {
        path: '/houseOrderPay',
        name: 'houseOrderPay',
        component: () => import('../views/houseOrderPay.vue')
    }
]

const router = new VueRouter({
    routes
})

export default router
